import { useState } from 'react'
import ProjectCard from "./ProjectCard.jsx";
import ProjectModal from "./ProjectModal";
import './styles/projects.css'
import { PROJECTS } from '../constants.js'

export default function Projects() {
  const [activeProject, setActiveProject] = useState(null);

  return (
    <section id="projects" className="section">
      <h1>{"Projects {"}</h1>

      <div className="projects-grid">
        {PROJECTS.map((p, i) => (
          <ProjectCard key={i} project={p} onOpen={setActiveProject} />
        ))}
      </div>

      {activeProject && (
        <ProjectModal
          project={activeProject}
          onClose={() => setActiveProject(null)}
        />
      )}
      <h1>{"}"}</h1>
    </section>
  );
}
